import { renderLoader } from 'components/system/loadable/renderLoader'

export const withLoader = {
  /** для файла с описанием дженерик типов, нельзя использовать TSX */
  fallback: renderLoader(),
}
